import breakpoints from './breakpoints'

export default () => {
  const width = window.outerWidth
  let viewable = 0

  if (width <= breakpoints.xs.max) {
    viewable = 2
  } else if (width >= breakpoints.sm.min && width <= breakpoints.sm.max) {
    viewable = 3
  } else if (width >= breakpoints.md.min && width <= breakpoints.md.max) {
    viewable = 4
  } else if (width >= breakpoints.lg.min && width <= breakpoints.lg.max) {
    viewable = 5
  } else if (width >= breakpoints.xl.min) {
    viewable = 6
  }

  return viewable
}



// WEBPACK FOOTER //
// ./src/common/lib/viewable-slides.js